module.exports = (array) => {
    const unique = (value, index, self) => {
        return self.indexOf(value) === index
    }
    return array.filter(unique);
}